/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux'
import { AUTH_CONFIG } from '../../../../Auth/auth0-variables';
import axios from 'axios';
import {
    SearchBox, Pivot, PivotItem, ShimmeredDetailsList, SelectionMode, Persona, PersonaSize, PrimaryButton, IconButton, IActivityItemProps, Link, mergeStyleSets
} from '@fluentui/react';
import $ from 'jquery'
import moment from 'moment'
import {
    isToday,
    differenceInCalendarDays,
    format,
} from 'date-fns'
import ActivityItem from './ActivityItem'
import DOMPurify from 'dompurify';
import { Shimmer, ShimmerElementsGroup, ShimmerElementType } from '@fluentui/react/lib/Shimmer';

const signalR = require("@microsoft/signalr");

const container = () => css`
  
`;
class Chats extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: true,
            type: this.props.headerKey ? this.props.headerKey : "Chats",
            chats: [],
            announcements: [],
            isFetchingAnnouncements: true,
            selectedChatTab:null
        };
    }

    componentDidMount() {
        this.getChats();
        
        const hubConnection = new signalR.HubConnectionBuilder().withUrl(AUTH_CONFIG.API_URL + '/TwilioHub', {
            skipNegotiation: true,
            transport: signalR.HttpTransportType.WebSockets
        }).build();

        this.setState({ hubConnection, isFetching:true }, () => {
            this.state.hubConnection
                .start()
                .then(() => { })
                .catch(err => { });
            this.state.hubConnection.on('newChatMsg', (response, replyText) => {
                this.getChats();
            });
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.facilityId !== this.props.facilityId) {
            this.setState({
                nextProps
            }, () => {
                this.getChats();
            });
        }
        if (nextProps.selectedAnnouncementId !== this.props.selectedAnnouncementId) {
            debugger;
            this.setState({
                selectedAnnouncementId: nextProps.selectedAnnouncementId
            }, () => {
                this.getChats(nextProps.selectedAnnouncementId);
            });
        }
    }


    getChats = (selectedAnnouncementId) => {
        debugger;
        axios.get(AUTH_CONFIG.API_URL + "/api/Schedules/GetChats?facilityId=" + this.props.facilityId)
            .then((response) => {
                response.data.forEach((s, index) => {
                    debugger;
                    s.timeStamp = this.formatDate(moment(s.timeStamp).toDate())
                    s.activityPersonas.forEach((a, index) => {
                        debugger;
                        a.imageUrl = a.imageUrl ? process.env.REACT_APP_CDN_URL + a.imageUrl : null
                    })
                })
                console.log(JSON.stringify(response.data))
                this.setState({
                    showBubble: response.data.length > 0 && response.data.filter(x => !x.seen).length > 0,
                    chats: response.data,
                    isFetching: false
                }, () => {
                    debugger;
                    if (!this.props.bot && response.data.length && !selectedAnnouncementId) {
                        this.chatClick(response.data[0], null)
                    }
                });

                if (this.props.expanded && !selectedAnnouncementId) {
                    this.props.callback(2, 1, response.data[0].chatID, response.data[0])
                }
            });
        axios.get(AUTH_CONFIG.API_URL + "/api/Schedules/GetAnnouncements?facilityId=" + this.props.facilityId)
            .then((response) => {
                
                response.data.forEach((s, index) => {
                    s.createdOn = this.formatDate(moment(s.createdOn).toDate())
                })
                
                this.setState({
                    announcements: response.data,
                    isFetchingAnnouncements: false
                }, () => {
                    if (selectedAnnouncementId) {
                        this.props.callback(5, 1, null, this.state.announcements.filter(x => x.announcementId === selectedAnnouncementId)[0])
                    }
                });
            });
    }

    handleLinkClick = (item) => {
        this.setState({
            type: item.props.path
        })
        this.props.typeCallback && this.props.typeCallback(item.props.path)
    };

    formatDate = (time) => {
        if (isToday(time)) {
            return format(time, 'h:mm a');
        } else if (differenceInCalendarDays(new Date(), time) < 8) {
            return format(time, 'EEEE');
        } else {
            return format(time, 'd/yy');
        }
    }

    chatClick = (item, e) => {
        $('.chat-item').removeClass('active')
        this.props.callback(2, 1, item.chatID, item);
        this.setState({
            selectedChatTab: item.chatID
        })
       // $(e.target).closest('.chat-item').addClass("active"); 
        
    }

    _buildAnnouncement = (item) => {
        debugger;
        const stripHtml = (html) => DOMPurify.sanitize(html, { ALLOWED_TAGS: [] });

        return <div className={`flex-column width100 py10 announcement-item hover-cursor ${this.state.selectedAnnouncementId == item.announcementId ? 'active' : ''}`} onClick={() => { this.props.callback(5, 1, null, item); this.setState({ selectedAnnouncementId: item.announcementId }) } } style={{ borderBottom:'1px solid rgba(var(--palette-neutral-100), 0.08)'} }>
            <div className="flex-row spacebetween mb5">
                <h4 className="head-xs" style={{ color: "var(--palette-black-alpha-100)", fontSize: 15, textOverflow:'ellipsis', whiteSpace:'nowrap', overflow:'hidden' }}>{item.title}</h4>
                <p className="label-small no-wrap">{item.createdOn}</p>
            </div>
            <p className="text-ellipses" style={{ marginBottom: 3, width: '80%' }}>{stripHtml(item.description)}</p>
            {(this.props.user.userType == '1' || this.props.user.userType == '2') && <p className="label-small mb10">{item.users.length} Employees at {this.props.facilityName}</p>}
            <div className={`flex-row ${(item.attachments.length > 0) && this.props.planType !== 'Free' ? 'spacebetween' : 'justifyflexend'}`}>
                {this.props.planType !== 'Free' && (item.users.length > 0) && item.required && (this.props.user.userType == '1' || this.props.user.userType == '2') && 
                    <div className="required-pill p5">{item.users.filter(x=>x.seen).length}/{item.users.length}</div>
                }
                {(item.attachments.length > 0) &&
                    <p className="secondary-medium"> <i className="ms-Icon ms-Icon--Attach mr5" style={{ fontSize: 16 }}></i>{item.attachments.length }</p>
                }
            </div>
        </div>
    }

    getCustomElementsExampleOne = ()  => {
        return (
            <div className="flexcolumn">
                <div className="displayflex aligncenter shim-container" >
                    <ShimmerElementsGroup
                        shimmerElements={[
                            { type: ShimmerElementType.circle, height: 40 },
                            { type: ShimmerElementType.gap, width: 10, height: 40 },
                        ]}
                    />
                    <ShimmerElementsGroup
                        flexWrap
                        shimmerElements={[
                            { type: ShimmerElementType.line, width: 400, height: 10 },
                            { type: ShimmerElementType.gap, width: 100, height: 20 },
                            { type: ShimmerElementType.line, width: 500, height: 10 },
                        ]}
                    />
                </div>
                <div className="spacer"></div>
                <div className="displayflex aligncenter shim-container">
                    <ShimmerElementsGroup
                        shimmerElements={[
                            { type: ShimmerElementType.circle, height: 40 },
                            { type: ShimmerElementType.gap, width: 10, height: 40 },
                        ]}
                    />
                    <ShimmerElementsGroup
                        flexWrap
                        shimmerElements={[
                            { type: ShimmerElementType.line, width: 400, height: 10 },
                            { type: ShimmerElementType.gap, width: 100, height: 20 },
                            { type: ShimmerElementType.line, width: 500, height: 10 },
                        ]}
                    />
                </div>
                <div className="spacer"></div>

                <div className="displayflex aligncenter shim-container">
                    <ShimmerElementsGroup
                        shimmerElements={[
                            { type: ShimmerElementType.circle, height: 40 },
                            { type: ShimmerElementType.gap, width: 10, height: 40 },
                        ]}
                    />
                    <ShimmerElementsGroup
                        flexWrap
                        shimmerElements={[
                            { type: ShimmerElementType.line, width: 400, height: 10 },
                            { type: ShimmerElementType.gap, width: 100, height: 20 },
                            { type: ShimmerElementType.line, width: 500, height: 10 },
                        ]}
                    />
                </div>
                <div className="spacer"></div>

                <div className="displayflex aligncenter shim-container">
                    <ShimmerElementsGroup
                        shimmerElements={[
                            { type: ShimmerElementType.circle, height: 40 },
                            { type: ShimmerElementType.gap, width: 10, height: 40 },
                        ]}
                    />
                    <ShimmerElementsGroup
                        flexWrap
                        shimmerElements={[
                            { type: ShimmerElementType.line, width: 400, height: 10 },
                            { type: ShimmerElementType.gap, width: 100, height: 20 },
                            { type: ShimmerElementType.line, width: 500, height: 10 },
                        ]}
                    />
                </div>
                <div className="spacer"></div>

                <div className="displayflex aligncenter shim-container">
                    <ShimmerElementsGroup
                        shimmerElements={[
                            { type: ShimmerElementType.circle, height: 40 },
                            { type: ShimmerElementType.gap, width: 10, height: 40 },
                        ]}
                    />
                    <ShimmerElementsGroup
                        flexWrap
                        shimmerElements={[
                            { type: ShimmerElementType.line, width: 400, height: 10 },
                            { type: ShimmerElementType.gap, width: 100, height: 20 },
                            { type: ShimmerElementType.line, width: 500, height: 10 },
                        ]}
                    />
                </div>
                <div className="spacer"></div>

                <div className="displayflex aligncenter shim-container">
                    <ShimmerElementsGroup
                        shimmerElements={[
                            { type: ShimmerElementType.circle, height: 40 },
                            { type: ShimmerElementType.gap, width: 10, height: 40 },
                        ]}
                    />
                    <ShimmerElementsGroup
                        flexWrap
                        shimmerElements={[
                            { type: ShimmerElementType.line, width: 400, height: 10 },
                            { type: ShimmerElementType.gap, width: 100, height: 20 },
                            { type: ShimmerElementType.line, width: 500, height: 10 },
                        ]}
                    />
                </div>
            </div>
        );
    };

    render() {
        return (
            <div className="chat-list" css={container }>
               
                <div className="displayflex width100 aligncenter mb10 border-bottom-d1" style={{ padding: '0px 20px 0px 10px', justifyContent:'space-between'}} >
                    <Pivot onLinkClick={this.handleLinkClick} selectedKey={this.state.type}>
                        <PivotItem path="Chats" headerText="Chats" itemKey="Chats"></PivotItem>
                        <PivotItem path="Announcements" headerText="Announcements" itemKey="Announcements"></PivotItem>
                    </Pivot>
                    {!this.props.bot && <IconButton
                        styles={{
                            root: {
                                color: "black",
                                display: this.props.user.userType == "3" && this.state.type == 'Announcements' ? 'none' : 'block'
                            },
                            icon: { fontSize: 20 },
                            rootHovered: {
                                color: "black",
                            }
                        }}
                        iconProps={{ iconName: 'CirclePlus' }}
                        onClick={() => this.props.callback(this.state.type == 'Announcements' ? 4 : 3, 1)}
                    />}
                </div>
                {this.state.type == 'Chats' && (this.state.chats.length === 0) && !this.state.isFetching && <div className="flexcenter flexcolumn" style={{ maxHeight: 1000, height: '80%', minHeight: 400 }}>
                    <svg style={{ width: 200, height: 100 }} fill="currentColor" aria-hidden="true" width="1em" height="1em" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.75 3.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM3.5 5.75a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Zm0 4.25a2 2 0 0 0-2 2V12.08a1.72 1.72 0 0 0 .01.18 3.95 3.95 0 0 0 .67 1.8C2.88 15.09 4.24 16 6.75 16c.95 0 1.73-.13 2.37-.35A5.51 5.51 0 0 1 9 14.63c-.56.22-1.3.37-2.25.37-2.24 0-3.26-.8-3.74-1.5a2.95 2.95 0 0 1-.5-1.42l-.01-.02V12a1 1 0 0 1 1-1H10a1 1 0 0 1 .23.03c.23-.28.49-.54.76-.77A2 2 0 0 0 10 10H3.5Zm11-5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM12 6.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0ZM14.5 19a4.5 4.5 0 1 0-3.94-2.32l-.54 1.8c-.1.3.2.6.5.5l1.8-.54c.64.36 1.39.56 2.18.56ZM12 13.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Zm.5 2.5a.5.5 0 0 1 0-1h2a.5.5 0 0 1 0 1h-2Z" fill="#adadad"></path></svg>
                    <div className="secondary-medium mt20">No {this.state.type == 'Announcements' ? 'announcements' : 'chats'} yet</div>
                </div>}
                {this.state.type == 'Announcements' && (this.state.announcements.length === 0) && !this.state.isFetching &&  <div className="flexcenter flexcolumn" style={{ maxHeight: 1000, height: '80%', minHeight: 400 }}>
                    <svg style={{ width: 200, height: 100 }} fill="currentColor" aria-hidden="true" width="1em" height="1em" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.75 3.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM3.5 5.75a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Zm0 4.25a2 2 0 0 0-2 2V12.08a1.72 1.72 0 0 0 .01.18 3.95 3.95 0 0 0 .67 1.8C2.88 15.09 4.24 16 6.75 16c.95 0 1.73-.13 2.37-.35A5.51 5.51 0 0 1 9 14.63c-.56.22-1.3.37-2.25.37-2.24 0-3.26-.8-3.74-1.5a2.95 2.95 0 0 1-.5-1.42l-.01-.02V12a1 1 0 0 1 1-1H10a1 1 0 0 1 .23.03c.23-.28.49-.54.76-.77A2 2 0 0 0 10 10H3.5Zm11-5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM12 6.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0ZM14.5 19a4.5 4.5 0 1 0-3.94-2.32l-.54 1.8c-.1.3.2.6.5.5l1.8-.54c.64.36 1.39.56 2.18.56ZM12 13.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Zm.5 2.5a.5.5 0 0 1 0-1h2a.5.5 0 0 1 0 1h-2Z" fill="#adadad"></path></svg>
                    <div className="secondary-medium mt20">No {this.state.type == 'Announcements' ? 'announcements' : 'chats'} yet</div>
                </div>}
                {this.state.type == 'Chats' &&
                    <div className="custom-scrollbar chat-list-container height100" style={{  padding: 8, }}>
                        {this.state.chats.map((item) => {
                            // Clone personas before mutating
                            const filteredPersonas = (item.activityPersonas || [])
                                .filter(x => x.userID !== this.props.user.userId)
                                .slice(0, 2);

                            // Skip rendering if nothing to show
                            if (filteredPersonas.length === 0) return null;

                            return (
                                <div
                                    key={item.chatID}
                                    onClick={(e) => this.chatClick(item, e)}
                                    className={`prelative chat-item ${this.state.selectedChatTab === item.chatID ? 'active' : ''} ${filteredPersonas.length === 2 ? 'chat-two' : ''}`}
                                >
                                    <ActivityItem {...item} activityPersonas={filteredPersonas} />
                                </div>
                            );
                        })
}
                        {!this.props.bot && this.state.isFetching && <div className="mr10 ml5 mt10 chat-shimmer"><Shimmer customElementsGroup={this.getCustomElementsExampleOne()} width="300" /></div>}
                    </div>
                }
                {this.state.type == 'Announcements' &&
                    <div className="custom-scrollbar displayflex flexcolumn aligncenter pt10 px20" style={{ height:'calc(100% - 60px)', overflowX: 'hidden'} }>
                    {this.state.announcements.map((item) => {
                        return this._buildAnnouncement(item)
                    })}
                </div>
                }
                
                
            </div>
        );
    }
}

function mapStateToProps(state) {
    const facilityId = state.appState.product.facility.facilityID;
    const facilityName = state.appState.product.facility.name;
    const user = state.userProfile;
    const product = state.appState.product.slug;
    const planType = state.appState.planType;

    return {
        facilityId,
        product,
        user,
        facilityName,
        planType
    }
}

const ConnectedChats = connect(mapStateToProps, null, null, { forwardRef: true })(Chats);
export default React.forwardRef((props, ref) => <ConnectedChats {...props} ref={ref} />);

